import { useEffect } from 'react';
import { useToggles } from '../../../state/toggles';
import { useApp, useAppDispatchers } from '../../../state/app';
import { useUser } from '../../../state/user';

const pmaCompletedStates = ['success', 'failure', 'invalidated'];

const useProveMobileAuth = () => {
  const { proveMobileAuthEnabled } = useToggles();
  const { proveMobileAuthState, regAccessToken, mockPma, proveRedirectUri } =
    useApp();
  const { tempPhoneNumber } = useUser();

  const { getProveRedirectUri } = useAppDispatchers();

  useEffect(() => {
    if (proveMobileAuthEnabled && !proveMobileAuthState) {
      getProveRedirectUri({ mockPma });
    }
  }, [proveMobileAuthEnabled]);

  useEffect(() => {
    if (
      proveMobileAuthState === 'pending' &&
      !tempPhoneNumber &&
      !regAccessToken
    ) {
      if (mockPma.enabled) {
        // If the redirect url is missing protocol we need to add it
        if (!/^(https?:\/\/)/.test(proveRedirectUri)) {
          proveRedirectUri = `http://${proveRedirectUri}`;
        }
        window.location.replace(
          proveRedirectUri.concat(
            `&mockProveAuth=true&state=${mockPma.state}&pmaPhone=${mockPma.phone}`
          )
        );
      }
      window.location.replace(proveRedirectUri);
    }
  }, [proveMobileAuthState]);
};

export default useProveMobileAuth;
